import * as v from 'valibot';
import Ajax from '../util/ajax';
import { deviceUpdated } from '../features/devices/devicesSlice';
import { deviceSchema } from '../types/device';
export function saveDevice(device_id, title) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch);
        const url = '/device/' + device_id;
        const obj = {
            title
        };
        ajax.post(url, obj, data => {
            const res = v.safeParse(deviceSchema, data);
            if (res.success) {
                dispatch(deviceUpdated(res.output));
            }
            else {
                console.error(v.summarize(res.issues));
            }
        });
    };
}
